import createConverter from './lib/create_converter';
import RoutingGroup from 'models/routing_group';

export default createConverter(RoutingGroup);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/routing_group_converter.js